// api-client redirects to sign-in when a session is unrecoverable, but it must
// not import the router singleton: router pulls in routeTree, routeTree pulls
// in every route, and routes import back into core/lib/api. the app entrypoint
// injects the live instance here instead, so the dependency runs one way.
export interface AuthRouter {
  state: { location: { pathname: string; searchStr: string } };
  navigate: (
    options:
      | { to: "/auth/sign-in"; search?: { redirect: string } }
      | { to: "/auth/terms"; replace: true },
  ) => void;
}

let routerImpl: AuthRouter = {
  state: { location: { pathname: "", searchStr: "" } },
  navigate: () => {},
};

export function initAuthRouter(router: AuthRouter): void {
  routerImpl = router;
}

export function authCurrentLocation(): AuthRouter["state"]["location"] {
  return routerImpl.state.location;
}

export function redirectToSignIn(redirect?: string): void {
  routerImpl.navigate({
    to: "/auth/sign-in",
    search: redirect ? { redirect } : undefined,
  });
}

export function redirectToTerms(): void {
  routerImpl.navigate({ to: "/auth/terms", replace: true });
}
